<template>
    <div class="adjust-forecast">
        <h3>{{$t('planner.AdjustReturnForecasts')}}</h3>
        <div>
            <el-form :label-position="'left'" label-width="100px" ref="form" :model="form">
                <el-form-item class="layout-flex">
                    <span class="head-title">{{$t('planner.Growth')}}</span>
                    <span class="head-title">{{$t('planner.Yield')}}</span>
                </el-form-item>
                <el-form-item class="layout-flex" :label="$t('planner.Cash')">
                    <div class="p-relative">
                        <numeric-input type="number" v-model="form.cash.growth"></numeric-input>
                        <span class="append placeholderPend">%</span>
                    </div>
                    <div class="p-relative">
                        <numeric-input type="number" v-model="form.cash.yield"></numeric-input>
                        <span class="append placeholderPend">%</span>
                    </div>
                </el-form-item>
                <el-form-item class="layout-flex" :label="$t('planner.Stocks')">
                    <div class="p-relative">
                        <numeric-input type="number" v-model="form.stocks.growth"></numeric-input>
                        <span class="append placeholderPend">%</span>
                    </div>
                    <div class="p-relative">
                        <numeric-input type="number" v-model="form.stocks.yield"></numeric-input>
                        <span class="append placeholderPend">%</span>
                    </div>
                </el-form-item>
                <el-form-item class="layout-flex" :label="$t('planner.Bonds')">
                    <div class="p-relative">
                        <numeric-input type="number" v-model="form.bonds.growth"></numeric-input>
                        <span class="append placeholderPend">%</span>
                    </div>
                    <div class="p-relative">
                        <numeric-input type="number" v-model="form.bonds.yield"></numeric-input>
                        <span class="append placeholderPend">%</span>
                    </div>
                </el-form-item>
                <el-form-item class="layout-flex" :label="$t('planner.RealEstate')">
                    <div class="p-relative">
                        <numeric-input type="number" v-model="form.real_estate.growth"></numeric-input>
                        <span class="append placeholderPend">%</span>
                    </div>
                    <div class="p-relative">
                        <numeric-input type="number" v-model="form.real_estate.yield"></numeric-input>
                        <span class="append placeholderPend">%</span>
                    </div>
                </el-form-item>
                <el-form-item class="layout-flex" :label="$t('planner.Other')">
                    <div class="p-relative">
                        <numeric-input type="number" v-model="form.other.growth"></numeric-input>
                        <span class="append placeholderPend">%</span>
                    </div>
                    <div class="p-relative">
                        <numeric-input type="number" v-model="form.other.yield"></numeric-input>
                        <span class="append placeholderPend">%</span>
                    </div>
                </el-form-item>
                <el-button type="primary" @click="submit">{{$t('planner.SaveChanges')}}</el-button>
            </el-form>
        </div>
    </div>
</template>
<style lang="scss" >
.adjust-forecast {
    .layout-flex {
        display: flex;
        align-items: center;
        position: relative;

        .p-relative {
            position: relative;
            .placeholderPend {
                position: absolute;
                right: 15px;
                top: 0;
            }
        }
        .head-title {
            display: inline-block;
            font-family: GothamBook;
            font-size: 14px;
            line-height: 1;
            color: #4a4a4a;
            width: 100%;
            min-width: 147px;
            @media (max-width: 768px) {
                min-width: 168px;
            }
            @media (max-width: 414px) {
                min-width: 74px;
            }
            margin-left: 10px;
        }
    }
    .el-form-item__label {
        font-family: GothamBook;
        font-size: 14px;
        height: 40px;
        line-height: normal;
        color: #4a4a4a;
    }
    .el-input__inner {
        border-radius: 4px;
        border: solid 1px #e0e7ff;
        background-color: rgba(224, 231, 255, 0.2);
        padding-left: 15px;
        font-family: GothamMedium;
        font-size: 14px;
        line-height: 1;
        color: var(--brownish-grey);
        &:focus {
            border-color: var(--windows-blue);
        }
    }
    .el-form-item__content {
        display: flex;
        justify-content: space-between;
        position: absolute;
        left: 0;
        top: 0;
        .p-relative:last-child {
            margin-left: 10px;
        }
    }
    .el-button {
        border: none;
        box-shadow: none;
        width: 100%;
        border-radius: 4px;
        background-color: var(--windows-blue);
        font-family: GothamMedium;
        font-size: 14px;
        line-height: 1.5;
        text-align: center;
        color: var(--white);
        &:hover,
        &:focus {
            background-color: var(--windows-blue);
        }
    }
}
</style>

<script>
import numericInput from "@/components/common/numeric-input.vue";
let loading;

export default {
    name: "adjustForecasts",
    props: ["savings", "requestParams", "requestHeaders"],
    data() {
        const $t = this.$t.bind(this);
        return {
            form: {
                cash: {
                    growth: this.savings.cash.growth,
                    yield: this.savings.cash.yield
                },
                stocks: {
                    growth: this.savings.stocks.growth,
                    yield: this.savings.stocks.yield
                },
                bonds: {
                    growth: this.savings.bonds.growth,
                    yield: this.savings.bonds.yield
                },
                real_estate: {
                    growth: this.savings.real_estate.growth,
                    yield: this.savings.real_estate.yield
                },
                other: {
                    growth: this.savings.other.growth,
                    yield: this.savings.other.yield
                }
            }
        };
    },
    beforeMount() {},

    mounted() {},

    methods: {
        loading() {
            loading = this.$loading({
                lock: true,
                target: ".main-container",
                text: this.$t("searchResultPage.loading"),
                color: "#3b6bbf",
                background: "rgba(255, 255, 255, 0.8)"
            });
        },

        submit() {
            this.loading();
            let allocationsUrl = `${this.requestParams.ppbApi}api/savings/`;
            let parameters = this.form;
            parameters.investment_interests = "RETURNS_2_5_YEARS";

            this.$http
                .patch(allocationsUrl, parameters, this.requestHeaders)
                .then(result => {
                    loading.close();
                    if (result.status == "200") {
                        this.$emit("goTo", "");
                    }
                })
                .catch(err => {});
        }
    },

    filters: {},

    watch: {},

    components: {
        numericInput
    }
};
</script>


// WEBPACK FOOTER //
// src/components/account/adjustForecasts.vue